import axios from '@_system/axios/axios.js'
export default {
	path: '/expressreconciliation',
	initdetail(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/initdetail', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getdetail(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/getdetail', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	listcarrier(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/listcarrier', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	updatecarrier(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/updatecarrier', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getgroup(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getgroup', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	uploadfile(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/uploadfile', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	updateprice(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/updateprice', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	resetsettlementamount(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/resetsettlementamount', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	regrab(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/regrab', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	
	savebill(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/savebill', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	download(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/download', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	autocheck(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/autocheck', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	fastreconciliation(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/fastreconciliation', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/admin/expressreconciliation.expressreconciliation', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},

	// saleorderimport(id, data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderimport/' + id, data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
	// saleorderexport(data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderexport', data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
}
